import { useEffect, useState } from "react";
import { call } from "../../funcStore";
import { getVtuberCount } from "../../api/commonApi";

const styles = {
  page: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  homeMain: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '32px',
    padding: '24px',
  },
  homeHero: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    textAlign: 'center',
    maxWidth: '480px',
  },
  homeTitle: {
    margin: 0,
    fontSize: '2rem',
  },
  spHomeTitle: {
    margin: 0,
    fontSize: '1.5rem',
  },
  homeDescription: {
    margin: 0,
    color: '#555',
  },
  homeCount: {
    margin: 0,
    color: '#4b3f8f',
    fontWeight: 'bold',
  },
  submitButton: {
    marginTop: '8px',
    padding: '10px',
    border: 'none',
    borderRadius: '4px',
    background: '#4b3f8f',
    color: '#fff',
    fontWeight: 'bold',
    cursor: 'pointer',
    width:250,
  },
  createButton: {
    padding: '10px',
    border: '1px solid #4b3f8f',
    borderRadius: '4px',
    background: '#fff',
    color: '#4b3f8f',
    fontSize: '0.9rem',
    cursor: 'pointer',
    width: 250,
  },
  createNote: {
    margin: 0,
    fontSize: '0.8rem',
    color: '#888',
  },
  homeSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
    maxWidth: '960px',
  },
  homeSectionTitle: {
    margin: 0,
    fontSize: '1.25rem',
  },
  homeSectionDescription: {
    margin: 0,
    color: '#555',
    fontSize: '0.9rem',
  },
  resultGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
    gap: '16px',
  },
  trendingHeader: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
  },
  trendingTabs: {
    display: 'flex',
    gap: '8px',
  },
  trendingTab: {
    border: '1px solid #ddd',
    background: '#fff',
    borderRadius: '16px',
    padding: '4px 14px',
    fontSize: '0.85rem',
    color: '#555',
    cursor: 'pointer',
  },
  trendingTabActive: {
    border: '1px solid #4b3f8f',
    background: '#4b3f8f',
    color: '#fff',
  },
};

export default function NavSearch() {
  //componentKey
  const COMPONENT_KEY = "NavSearch";

  //state
  const STATE_BEFORE_INIT = "beforeInit";
  const STATE_SP = "sp";
  const STATE_PC = "pc";

  const [state, setState] = useState(STATE_BEFORE_INIT);
  const [vtuberCount, setVtuberCount] = useState(null);

  //effect
  useEffect(() => {
    if (state == STATE_BEFORE_INIT) {
      setState(call("PCSP.getState"));
    }
  }, [state]);

  useEffect(() => {
    getVtuberCount()
      .then(setVtuberCount)
      .catch(() => {});
  }, []);


  const handleStartClick = () => {
    call('app.navigateToSearch');
  };

  const handleCreateClick = () => {
    call('app.navigateToCreate');
  };

  return (
    <div style={styles.homeHero}>
      <h1 style={state === STATE_SP ?styles.spHomeTitle:styles.homeTitle}>VTuber発見・検索サービス</h1>
      <p style={styles.homeDescription}>
        VTuberの情報をDB化し、配信傾向や特徴から自分好みのVTuberを検索・発見できるサービスです。
      </p>
      {vtuberCount !== null && (
        <p style={styles.homeCount}>
          累計{vtuberCount.toLocaleString()}人以上のVTuberを掲載中
        </p>
      )}
      <button
        type="button"
        style={styles.submitButton}
        onClick={handleStartClick}
      >
        VTuberを検索する
      </button>

      <button
        type="button"
        style={styles.createButton}
        onClick={handleCreateClick}
      >
        自分のページを作る
      </button>
      <p style={styles.createNote}>
        VTuberの方は、無料でご自身のページを作成できます
      </p>
    </div>
  );
}
